import type { FC } from 'react';
import { useCallback, useEffect } from 'react';
import { useSwipeable } from 'react-swipeable';
import { selectChangeStatusDelay, selectCreateCouponIsLoadingV2, selectOpenedCashOutCoupon, selectOpenedInsuranceCoupon } from '@mwl/core-lib';
import type { PopupClasses } from '@/components/Popup/Popup';
import { Popup } from '@/components/Popup/Popup';
import { useTypedDispatch, useTypedSelector } from '@/hooks';
import { selectCouponPreviewState, selectIsShowMobileCoupon, setShowPreviewCoupon } from '@/store';
import { CouponWrapper } from '../CouponWrapper/CouponWrapper';
import type { CouponMobilePreviewProps } from './CouponMobilePreview.types';
import styles from './CouponMobilePreview.module.scss';
const popupClasses: PopupClasses = {
  wrapper: styles.popupWrapper,
  container: styles.popupContainer,
  overlay: styles.popupOverlay
};
const CouponMobilePreview: FC<CouponMobilePreviewProps> = () => {
  const dispatch = useTypedDispatch();
  const isShowPreviewCoupon = useTypedSelector(selectCouponPreviewState);
  const isShowMobileCoupon = useTypedSelector(selectIsShowMobileCoupon);
  const statusDelay = useTypedSelector(selectChangeStatusDelay);
  const isCouponLoading = useTypedSelector(selectCreateCouponIsLoadingV2);
  const isShowMobileCouponInsurance = !!useTypedSelector(selectOpenedInsuranceCoupon);
  const isShowMobileCouponCashOut = !!useTypedSelector(selectOpenedCashOutCoupon);
  const isShowProgress = isCouponLoading || !!statusDelay;
  const handleClose = useCallback(() => {
    dispatch(setShowPreviewCoupon(false));
  }, [dispatch]);
  const handlers = useSwipeable({
    onSwipedDown: handleClose
  });
  useEffect(() => {
    if (isShowProgress && !isShowMobileCoupon) {
      dispatch(setShowPreviewCoupon(true));
    }
  }, [isShowProgress, dispatch, isShowMobileCoupon]);
  return <Popup onClose={handleClose} show={isShowPreviewCoupon} disableClickOutside={isShowMobileCouponInsurance || isShowMobileCouponCashOut} withCloseButton={false} withDragBar radius="none" className={styles.popupRoot} classes={popupClasses} data-sentry-element="Popup" data-sentry-component="CouponMobilePreview" data-sentry-source-file="CouponMobilePreview.tsx">
      <CouponWrapper swipeableHandlers={handlers} variant="preview" data-sentry-element="CouponWrapper" data-sentry-source-file="CouponMobilePreview.tsx" />
    </Popup>;
};
export { CouponMobilePreview };